import { FC } from 'react';

export const Mascot: FC = () => (
  <svg viewBox="0 0 120 120" aria-hidden focusable="false">
    <circle cx="60" cy="60" r="58" fill="#FFF1CC" />
    <rect x="34" y="28" width="52" height="44" rx="14" fill="#FFBB00" />
    <circle cx="28" cy="48" r="8" fill="#FFCA58" />
    <circle cx="92" cy="48" r="8" fill="#FFCA58" />
    <rect x="42" y="36" width="36" height="26" rx="6" fill="#FFFCF3" />
    <rect x="46" y="42" width="12" height="10" rx="3" fill="#212C3B" />
    <rect x="62" y="42" width="12" height="10" rx="3" fill="#212C3B" />
    <path
      d="M52 54c2.5 3 13.5 3 16 0"
      stroke="#212C3B"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
    />
    <line x1="60" y1="28" x2="60" y2="18" stroke="#FFBB00" strokeWidth="3" strokeLinecap="round" />
    <circle cx="60" cy="15" r="4" fill="#FFD666" />
    <rect x="40" y="74" width="40" height="28" rx="10" fill="#FFBB00" />
    <text
      x="60"
      y="92"
      textAnchor="middle"
      fontSize="7"
      fontFamily="Open Sans, sans-serif"
      fontWeight="700"
      fill="#212C3B"
    >
      MEMRISE
    </text>
  </svg>
);
